"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TIMEZONES_GMT_NAMES = void 0;
var UNKNOWN = 'n_a';
var DATELINE_STANDARD_TIME = 'GMT-12:00';
var SAMOA_STANDARD_TIME = 'GMT-11:00';
var HAWAIIAN_STANDARD_TIME = 'GMT-10:00';
var ALASKAN_STANDARD_TIME = 'GMT-09:00';
var PACIFIC_STANDARD_TIME = 'GMT-08:00';
var MOUNTAIN_MEXICO_US_MOUNTAIN_STANDARD_TIME = 'GMT-07:00';
var CENTRAL_STANDARD_CANADA_CENTRAL_MEXICO_CENTRAL_AMERICA_STANDARD_TIME = 'GMT-06:00';
var EASTERN_US_EASTERN_SA_PACIFIC_STANDARD_TIME = 'GMT-05:00';
var ATLANTIC_SA_WESTERN_PACIFIC_SA_STANDARD_TIME = 'GMT-04:00';
var NEWFOUNDLAND_AND_LABRADOR_STANDARD_TIME = 'GMT-03:30';
var E_SOUTH_AMERICA_SA_EASTERN_GREENLAND_STANDARD_TIME = 'GMT-03:00';
var MID_ATLANTIC_STANDARD_TIME = 'GMT-02:00';
var AZORES_CAPE_VERDE_STANDARD_TIME = 'GMT-01:00';
var GMT_GREENWICH_STANDARD_TIME = 'GMT';
var CENTRAL_EUROPE_CENTRAL_EUROPEAN_ROMANCE_W_EUROPE_W_CENTRAL_AFRICA_STANDARD_TIME = 'GMT+01:00';
var E_EUROPE_EGYPT_FLE_GTB_ISRAEL_SOUTH_AFRICA_STANDARD_TIME = 'GMT+2';
var RUSSIAN_ARAB_E_AFRICA_ARABIC_STANDARD_TIME = 'GMT+3';
var IRAN_STANDARD_TIME = 'GMT+3:30';
var ARABIAN_CAUCASUS_STANDARD_TIME = 'GMT+4';
var TRANSITIONAL_ISLAMIC_STATE_OF_AFGHANISTAN_STANDARD_TIME = 'GMT+4:30';
var EKATERINBURG_WEST_ASIA_STANDARD_TIME = 'GMT+5';
var INDIA_STANDARD_TIME = 'GMT+5:30';
var NEPAL_STANDARD_TIME = 'GMT+5:45';
var CENTRAL_ASIA_SRI_LANKA_N_CENTRAL_ASIA_STANDARD_TIME = 'GMT+6';
var MYANMAR_STANDARD_TIME = 'GMT+6:30';
var S_E_ASIA_NORTH_ASIA_STANDARD_TIME = 'GMT+7';
var CHINA_SINGAPORE_TAIPEI_W_AUSTRALIA_NORTH_ASIA_EAST_STANDARD_TIME = 'GMT+8';
var KOREA_TOKYO_YAKUTSK = 'GMT+9';
var A_U_S_CENTRAL_CEN_AUSTRALIA_STANDARD_TIME = 'GMT+9:30';
var A_U_S_EASTERN_E_AUSTRALIA_TASMANIA_VLADIVOSTOK_WEST_PACIFIC_STANDARD_TIME = 'GMT+10';
var CENTRAL_PACIFIC_STANDARD_TIME = 'GMT+11';
var FIJI_ISLANDS_NEW_ZEALAND_STANDARD_TIME = 'GMT+12';
var TONGA_STANDARD_TIME = 'GMT+13';
var TIMEZONES_GMT_NAMES = exports.TIMEZONES_GMT_NAMES = {
  UNKNOWN: UNKNOWN,
  DATELINE_STANDARD_TIME: DATELINE_STANDARD_TIME,
  SAMOA_STANDARD_TIME: SAMOA_STANDARD_TIME,
  HAWAIIAN_STANDARD_TIME: HAWAIIAN_STANDARD_TIME,
  ALASKAN_STANDARD_TIME: ALASKAN_STANDARD_TIME,
  PACIFIC_STANDARD_TIME: PACIFIC_STANDARD_TIME,
  MOUNTAIN_MEXICO_US_MOUNTAIN_STANDARD_TIME: MOUNTAIN_MEXICO_US_MOUNTAIN_STANDARD_TIME,
  CENTRAL_STANDARD_CANADA_CENTRAL_MEXICO_CENTRAL_AMERICA_STANDARD_TIME: CENTRAL_STANDARD_CANADA_CENTRAL_MEXICO_CENTRAL_AMERICA_STANDARD_TIME,
  EASTERN_US_EASTERN_SA_PACIFIC_STANDARD_TIME: EASTERN_US_EASTERN_SA_PACIFIC_STANDARD_TIME,
  ATLANTIC_SA_WESTERN_PACIFIC_SA_STANDARD_TIME: ATLANTIC_SA_WESTERN_PACIFIC_SA_STANDARD_TIME,
  NEWFOUNDLAND_AND_LABRADOR_STANDARD_TIME: NEWFOUNDLAND_AND_LABRADOR_STANDARD_TIME,
  E_SOUTH_AMERICA_SA_EASTERN_GREENLAND_STANDARD_TIME: E_SOUTH_AMERICA_SA_EASTERN_GREENLAND_STANDARD_TIME,
  MID_ATLANTIC_STANDARD_TIME: MID_ATLANTIC_STANDARD_TIME,
  AZORES_CAPE_VERDE_STANDARD_TIME: AZORES_CAPE_VERDE_STANDARD_TIME,
  GMT_GREENWICH_STANDARD_TIME: GMT_GREENWICH_STANDARD_TIME,
  CENTRAL_EUROPE_CENTRAL_EUROPEAN_ROMANCE_W_EUROPE_W_CENTRAL_AFRICA_STANDARD_TIME: CENTRAL_EUROPE_CENTRAL_EUROPEAN_ROMANCE_W_EUROPE_W_CENTRAL_AFRICA_STANDARD_TIME,
  E_EUROPE_EGYPT_FLE_GTB_ISRAEL_SOUTH_AFRICA_STANDARD_TIME: E_EUROPE_EGYPT_FLE_GTB_ISRAEL_SOUTH_AFRICA_STANDARD_TIME,
  RUSSIAN_ARAB_E_AFRICA_ARABIC_STANDARD_TIME: RUSSIAN_ARAB_E_AFRICA_ARABIC_STANDARD_TIME,
  IRAN_STANDARD_TIME: IRAN_STANDARD_TIME,
  ARABIAN_CAUCASUS_STANDARD_TIME: ARABIAN_CAUCASUS_STANDARD_TIME,
  TRANSITIONAL_ISLAMIC_STATE_OF_AFGHANISTAN_STANDARD_TIME: TRANSITIONAL_ISLAMIC_STATE_OF_AFGHANISTAN_STANDARD_TIME,
  EKATERINBURG_WEST_ASIA_STANDARD_TIME: EKATERINBURG_WEST_ASIA_STANDARD_TIME,
  INDIA_STANDARD_TIME: INDIA_STANDARD_TIME,
  NEPAL_STANDARD_TIME: NEPAL_STANDARD_TIME,
  CENTRAL_ASIA_SRI_LANKA_N_CENTRAL_ASIA_STANDARD_TIME: CENTRAL_ASIA_SRI_LANKA_N_CENTRAL_ASIA_STANDARD_TIME,
  MYANMAR_STANDARD_TIME: MYANMAR_STANDARD_TIME,
  S_E_ASIA_NORTH_ASIA_STANDARD_TIME: S_E_ASIA_NORTH_ASIA_STANDARD_TIME,
  CHINA_SINGAPORE_TAIPEI_W_AUSTRALIA_NORTH_ASIA_EAST_STANDARD_TIME: CHINA_SINGAPORE_TAIPEI_W_AUSTRALIA_NORTH_ASIA_EAST_STANDARD_TIME,
  KOREA_TOKYO_YAKUTSK: KOREA_TOKYO_YAKUTSK,
  A_U_S_CENTRAL_CEN_AUSTRALIA_STANDARD_TIME: A_U_S_CENTRAL_CEN_AUSTRALIA_STANDARD_TIME,
  A_U_S_EASTERN_E_AUSTRALIA_TASMANIA_VLADIVOSTOK_WEST_PACIFIC_STANDARD_TIME: A_U_S_EASTERN_E_AUSTRALIA_TASMANIA_VLADIVOSTOK_WEST_PACIFIC_STANDARD_TIME,
  CENTRAL_PACIFIC_STANDARD_TIME: CENTRAL_PACIFIC_STANDARD_TIME,
  FIJI_ISLANDS_NEW_ZEALAND_STANDARD_TIME: FIJI_ISLANDS_NEW_ZEALAND_STANDARD_TIME,
  TONGA_STANDARD_TIME: TONGA_STANDARD_TIME
};
var _default = exports["default"] = [{
  value: UNKNOWN,
  type: 'unknown',
  name: 'unknown',
  brand: 'unknown'
}, {
  value: DATELINE_STANDARD_TIME,
  type: 'Dateline Standard Time',
  name: 'Dateline Standard Time - (GMT-12:00) International Date Line West',
  brand: 'Netzsch NFT'
}, {
  value: SAMOA_STANDARD_TIME,
  type: 'Samoa Standard Time',
  name: 'Samoa Standard Time - (GMT-11:00) Midway Island, Samoa',
  brand: 'Netzsch NFT'
}, {
  value: HAWAIIAN_STANDARD_TIME,
  type: 'Hawaiian Standard Time',
  name: 'Samoa Standard Time - (GMT-10:00) Hawaii',
  brand: 'Netzsch NFT'
}, {
  value: ALASKAN_STANDARD_TIME,
  type: 'Alaskan Standard Time',
  name: 'Alaskan Standard Time - (GMT-09:00) Alaska',
  brand: 'Netzsch NFT'
}, {
  value: PACIFIC_STANDARD_TIME,
  type: 'Pacific Standard Time',
  name: 'Pacific Standard Time - (GMT-08:00) Pacific Time (US and Canada)',
  brand: 'Netzsch NFT'
}, {
  value: MOUNTAIN_MEXICO_US_MOUNTAIN_STANDARD_TIME,
  type: 'Mexico Standard Time 2',
  name: 'Mexico Standard Time 2 - (GMT-07:00) Mountain Time (US and Canada), Chihuahua, La Paz, Mazatlan, Arizona',
  brand: 'Netzsch NFT'
}, {
  value: CENTRAL_STANDARD_CANADA_CENTRAL_MEXICO_CENTRAL_AMERICA_STANDARD_TIME,
  type: 'Central America Standard Time',
  name: 'Central America Standard Time - (GMT-06:00) Central Time (US and Canada), Saskatchewan, Guadalajara, ' + 'Mexico City, Monterrey, Central America',
  brand: 'Netzsch NFT'
}, {
  value: EASTERN_US_EASTERN_SA_PACIFIC_STANDARD_TIME,
  type: 'S.A. Pacific Standard Time',
  name: 'S.A. Pacific Standard Time - (GMT-05:00) Eastern Time (US and Canada), Indiana (East), Bogota, Lima, Quito',
  brand: 'Netzsch NFT'
}, {
  value: ATLANTIC_SA_WESTERN_PACIFIC_SA_STANDARD_TIME,
  type: 'Atlantic Standard Time',
  name: 'Atlantic Standard Time - (GMT-04:00) Atlantic Time (Canada), Caracas, La Paz, Santiago',
  brand: 'Netzsch NFT'
}, {
  value: NEWFOUNDLAND_AND_LABRADOR_STANDARD_TIME,
  type: 'Newfoundland and Labrador Standard Time',
  name: 'Newfoundland and Labrador Standard Time - (GMT-03:30) Newfoundland and Labrador',
  brand: 'Netzsch NFT'
}, {
  value: E_SOUTH_AMERICA_SA_EASTERN_GREENLAND_STANDARD_TIME,
  type: 'S.A. Eastern Standard Time',
  name: 'S.A. Eastern Standard Time - (GMT-03:00) Brasilia, Buenos Aires, Georgetown, Greenland',
  brand: 'Netzsch NFT'
}, {
  value: MID_ATLANTIC_STANDARD_TIME,
  type: 'Mid-Atlantic Standard Time',
  name: 'Mid-Atlantic Standard Time - (GMT-02:00) Mid-Atlantic',
  brand: 'Netzsch NFT'
}, {
  value: AZORES_CAPE_VERDE_STANDARD_TIME,
  type: 'Azores Standard Time',
  name: 'Azores Standard Time - (GMT-01:00) Azores, Cape Verde Islands',
  brand: 'Netzsch NFT'
}, {
  value: GMT_GREENWICH_STANDARD_TIME,
  type: 'GMT Standard Time',
  name: 'GMT Standard Time - (GMT) Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London, Casablanca, Monrovia',
  brand: 'Netzsch NFT'
}, {
  value: CENTRAL_EUROPE_CENTRAL_EUROPEAN_ROMANCE_W_EUROPE_W_CENTRAL_AFRICA_STANDARD_TIME,
  type: 'Romance Standard Time',
  name: 'Romance Standard Time - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague, Sarajevo, Skopje, ' + 'Warsaw, Zagreb, Brussels, Copenhagen, Madrid, Paris, Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna, ' + 'West Central Africa',
  brand: 'Netzsch NFT'
}, {
  value: E_EUROPE_EGYPT_FLE_GTB_ISRAEL_SOUTH_AFRICA_STANDARD_TIME,
  type: 'Israel Standard Time',
  name: 'Israel Standard Time - (GMT+02:00) Bucharest, Cairo, Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius, ' + 'Athens, Istanbul, Minsk, Jerusalem, Harare, Pretoria',
  brand: 'Netzsch NFT'
}, {
  value: IRAN_STANDARD_TIME,
  type: 'Iran Standard Time',
  name: 'Iran Standard Time - (GMT+03:30) Tehran',
  brand: 'Netzsch NFT'
}, {
  value: ARABIAN_CAUCASUS_STANDARD_TIME,
  type: 'Arabian Standard Time',
  name: 'Arabian Standard Time - (GMT+04:00) Abu Dhabi, Muscat, Baku, Tbilisi, Yerevan',
  brand: 'Netzsch NFT'
}, {
  value: TRANSITIONAL_ISLAMIC_STATE_OF_AFGHANISTAN_STANDARD_TIME,
  type: 'Transitional Islamic State of Afghanistan Standard Time',
  name: 'Transitional Islamic State of Afghanistan Standard Time - (GMT+04:30) Kabul',
  brand: 'Netzsch NFT'
}, {
  value: EKATERINBURG_WEST_ASIA_STANDARD_TIME,
  type: 'West Asia Standard Time',
  name: 'West Asia Standard Time - (GMT+05:00) Ekaterinburg, Islamabad, Karachi, Tashkent',
  brand: 'Netzsch NFT'
}, {
  value: INDIA_STANDARD_TIME,
  type: 'India Standard Time',
  name: 'India Standard Time - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
  brand: 'Netzsch NFT'
}, {
  value: NEPAL_STANDARD_TIME,
  type: 'Nepal Standard Time',
  name: 'Nepal Standard Time - (GMT+05:45) Kathmandu',
  brand: 'Netzsch NFT'
}, {
  value: CENTRAL_ASIA_SRI_LANKA_N_CENTRAL_ASIA_STANDARD_TIME,
  type: 'Central Asia Standard Time',
  name: 'Central Asia Standard Time - (GMT+06:00) Astana, Dhaka, Sri Jayawardenepura, Almaty, Novosibirsk',
  brand: 'Netzsch NFT'
}, {
  value: MYANMAR_STANDARD_TIME,
  type: 'Myanmar Standard Time',
  name: 'Myanmar Standard Time - (GMT+06:30) Yangon Rangoon',
  brand: 'Netzsch NFT'
}, {
  value: S_E_ASIA_NORTH_ASIA_STANDARD_TIME,
  type: 'North Asia Standard Time',
  name: 'North Asia Standard Time - (GMT+07:00) Bangkok, Hanoi, Jakarta, Krasnoyarsk',
  brand: 'Netzsch NFT'
}, {
  value: CHINA_SINGAPORE_TAIPEI_W_AUSTRALIA_NORTH_ASIA_EAST_STANDARD_TIME,
  type: 'China Standard Time',
  name: 'China Standard Time - (GMT+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi, Kuala Lumpur, Singapore, ' + 'Taipei, Perth, Irkutsk, Ulaanbaatar',
  brand: 'Netzsch NFT'
}, {
  value: KOREA_TOKYO_YAKUTSK,
  type: 'Korea Standard Time',
  name: 'Korea Standard Time - (GMT+09:00) Seoul, Osaka, Sapporo, Tokyo, Yakutsk',
  brand: 'Netzsch NFT'
}, {
  value: A_U_S_CENTRAL_CEN_AUSTRALIA_STANDARD_TIME,
  type: 'A.U.S. Central Standard Time',
  name: 'A.U.S. Central Standard Time - (GMT+09:30) Darwin, Adelaide',
  brand: 'Netzsch NFT'
}, {
  value: A_U_S_EASTERN_E_AUSTRALIA_TASMANIA_VLADIVOSTOK_WEST_PACIFIC_STANDARD_TIME,
  type: 'A.U.S. Eastern Standard Time',
  name: 'A.U.S. Eastern Standard Time - (GMT+10:00) Canberra, Melbourne, Sydney, Brisbane, Hobart, Vladivostok, ' + 'Guam, Port Moresby',
  brand: 'Netzsch NFT'
}, {
  value: CENTRAL_PACIFIC_STANDARD_TIME,
  type: 'Central Pacific Standard Time',
  name: 'Central Pacific Standard Time - (GMT+11:00) Magadan, Solomon Islands, New Caledonia',
  brand: 'Netzsch NFT'
}, {
  value: FIJI_ISLANDS_NEW_ZEALAND_STANDARD_TIME,
  type: 'New Zealand Standard Time',
  name: 'New Zealand Standard Time - (GMT+12:00) Fiji Islands, Kamchatka, Marshall Islands, Auckland, Wellington',
  brand: 'Netzsch NFT'
}, {
  value: TONGA_STANDARD_TIME,
  type: 'Tonga Standard Time',
  name: "Tonga Standard Time - (GMT+13:00) Nuku'alofa",
  brand: 'Netzsch NFT'
}];